import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'widgets/Dialog';
import DialogActions from 'widgets/DialogUtils/DialogActions';
import DialogContent from 'widgets/DialogUtils/DialogContent';
import DialogTitle from 'widgets/DialogUtils/DialogTitle';
import Button from 'widgets/Button';
import colors from 'assets/styles/jsVariables/colors';
import { applyFixToWindowPosition, applyRelativeToWindowPosition } from 'libs/windowDimension';
import styles from './styles';
import Icon from '../Icon';

const cssStyles = {
  iconButtonStyle: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  paperStyle: {
    overflowY: 'auto',
    maxHeight: '80vh',
    '@media (orientation:landscape) and (max-width: 570px)': {
      margin: '48px 24px',
      maxHeight: '70vh',
    },
    '@media (max-width: 370px)': {
      margin: '24px'
    }
  }
};

class Modal extends React.Component {
  componentDidUpdate() {
    this.applyRelativeToWindowPosition();
  }

  applyRelativeToWindowPosition = () => {
    const { open } = this.props;
    setTimeout(() => {
      const modalEle = document.querySelector('.modalOpen');
      if (!open && !modalEle) {
        applyRelativeToWindowPosition();
      }
    });
  }
  render() {
    const {
      title,
      subTitle,
      className,
      id,
      open,
      toggleModal,
      children,
      iconName,
      iconStyle,
      iconFill,
      maxWidth,
      fullWidth,
      titleStyle,
      subTitleStyle,
      actions,
      containerStyle,
      childrenStyle,
      titleContainerStyle,
      paperStyle,
      showCross,
      onExited,
      disableEscapeKeyDown,
      disableBackdropClick
    } = this.props;

    if (open) {
      applyFixToWindowPosition();
    }

    return (
      <Dialog
        open={open}
        className={`${className} ${open ? 'modalOpen' : ''}`}
        id={id}
        onClose={toggleModal}
        cssStyles={{
          paper: cssStyles.paperStyle
        }}
        style={{
          ...styles.modal,
          ...containerStyle,
          position: 'absolute',
          bottom: '50px'
        }}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        onExited={onExited}
        disableEscapeKeyDown={disableEscapeKeyDown}
        disableBackdropClick={disableBackdropClick}
        BackdropProps={{
          style: {
            ...styles.overlayStyle,
            position: 'absolute',
            bottom: '-50px'
          }
        }}
        PaperProps={{ style: { ...styles.paperStyle, ...paperStyle } }}
      >
        <DialogTitle disableTypography style={{ ...styles.titleContainer, ...titleContainerStyle }}>
          {
            <div style={{ ...styles.title, ...titleStyle }}>
              {title}
              {subTitle && <div style={{ ...styles.subTitle, ...subTitleStyle }}>{subTitle}</div>}
              {
                showCross &&
                <Button
                  type="icon"
                  style={{ ...styles.xIcon, ...iconStyle, }}
                  onClick={toggleModal}
                  disableRipple
                  cssStyles={{ root: cssStyles.iconButtonStyle }}
                >
                  <Icon
                    name={iconName}
                    style={{
                      ...styles.iconContainer,
                      height: iconStyle.height || 14,
                      width: iconStyle.width || 14
                    }}
                    fill={iconFill || colors.lightGrey}
                  />
                </Button>
              }
            </div>
          }
        </DialogTitle>
        <DialogContent className="scrollbarModal" style={{ ...styles.bodyStyle, ...childrenStyle }}>
          <div>
            {children}
          </div>
        </DialogContent>
        <DialogActions>
          {actions}
        </DialogActions>
      </Dialog>
    );
  }
}

Modal.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  subTitle: PropTypes.string,
  open: PropTypes.bool.isRequired,
  fullWidth: PropTypes.bool,
  disableEscapeKeyDown: PropTypes.bool,
  disableBackdropClick: PropTypes.bool,
  maxWidth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  toggleModal: PropTypes.func,
  onExited: PropTypes.func,
  children: PropTypes.object.isRequired,
  iconName: PropTypes.string,
  iconFill: PropTypes.string,
  titleStyle: PropTypes.object,
  subTitleStyle: PropTypes.object,
  actions: PropTypes.array,
  iconStyle: PropTypes.object,
  containerStyle: PropTypes.object,
  titleContainerStyle: PropTypes.object,
  paperStyle: PropTypes.object,
  childrenStyle: PropTypes.object,
  showCross: PropTypes.bool,
};
Modal.defaultProps = {
  className: '',
  id: '',
  subTitle: null,
  disableBackdropClick: true,
  disableEscapeKeyDown: true,
  subTitleStyle: styles.subTitle,
  iconName: 'x-icon',
  iconFill: '',
  titleStyle: styles.title,
  fullWidth: false,
  maxWidth: false,
  actions: [],
  containerStyle: {},
  onExited: () => {},
  titleContainerStyle: {},
  paperStyle: {},
  childrenStyle: {},
  showCross: true,
  iconStyle: {},
  toggleModal: () => {}
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.jsx